import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';

export default function RequireAdminAuth({ children }) {
  const { isAuth } = useAdminAuth();
  if (!isAuth) return <Navigate to="/admin" replace />;
  return children;
}
